<!-- <ul class="breadcrumb">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Investment</li>
</ul> -->
<section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Register of Investments (other than securities not held in the name of the company)</strong>
      </span>
      <span style="float: right">
        <!-- <a routerLink="/investment"> -->
          <button (click)="add()" class="btn btn-success pull-right" [appHasPermission]="{'Url': '/register/investment/edit?goveva=true&email=', 'method':'put', 'menu': 'investment'}" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
        <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
          <span>
            <i class="fa fa-save"></i>&nbsp;Generate Output </span>
        </button>
      </span>
    </div>
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
        <span class="pull-right">
          <i class="fa fa-filter" aria-hidden="true"></i>
        </span>
      </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <!-- <form (document:click)="cesDate.close()"> -->
            <div class="row">
              <div class="col-md-3">
                <label>Name of the Person, in whose name the investments are held:</label>
                <div class="input-group">
                  <!-- <label>Nature of Documents Inspected </label> -->
                  <input type="text" class="form-control" [(ngModel)]="nameOfPerson"> &nbsp;&nbsp;&nbsp;
                </div>
                <br>
              </div>
              <!-- <div class="col-lg-4">
                <label>Date of Acquisition:
                </label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="dateOfAcquisition" [(ngModel)]="dateOfAcquisition" [minDate]="futureToDate"
                    class="form-control" style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfAcquisition"
                    ngbDatepicker #cesDate="ngbDatepicker" (click)="cesDate.toggle()"
                    [ngModelOptions]="{standalone: true}">
                  <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div> -->
              <div class="col-md-3">
                <br><br>
                <!-- <label>Date of Acquisition</label> -->
                <div class="input-group" (click)="$event.stopPropagation()">
                  From:&nbsp;
                  <input id="dateOfAcquisition" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfAcquisition" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfAcquisition">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
              <div class="col-md-3">
                
                <br><br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  To:&nbsp;
                  <input id="dateOfAcquisitionTo" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfAcquisitionTo" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfAcquisitionTo">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
              <div class="col-sm-2">
                <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                <br><br>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
            <!-- </form> -->
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfInvestment" [dtTrigger]="dtTriggerInvestment"
                class="table table-hover compact cell-border nowrap stripe" id="investmentlistTable"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Name of the Person, in whose <br>name the investments are held</th>
                    <th>Date of Acquisition</th>
                    <th style="display: none">Date of Acquisition</th>
                    <th>Date of title in the <br>name of the company</th>
                    <th style="display: none">Date of title in the name of the company</th>
                    <th class="actionclass">Action</th>
  
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;">
                    <td>
                      {{director.nameOfPerson}}
                    </td>
                    <td>
                      <span style="display: none">{{director.DateOfAcquisition | date : "yMMdd"}}</span>
                      {{director.DateOfAcquisition | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{director.DateOfAcquisition | date : "dd-MM-y"}}
                    </td>
                    <td>
                      <span style="display: none">{{director.dateOftitle | date : "yMMdd"}}</span>
                      {{director.dateOftitle | date : "dd-MM-y"}}
                    </td>
                    <td style="display: none">
                      {{director.dateOftitle | date : "dd-MM-y"}}
                    </td>
                    <td style='white-space: nowrap'>
                      <a>
                        <button type="button" [appHasPermission]="{'Url': '/register/investment/edit?goveva=true&email=', 'method':'put', 'menu': 'investment'}" (click)="editinvestmentdetail(director._id)" class="btn-sm btn btn-warning">
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                      <button type="button" class="btn-sm btn btn-danger" [appHasPermission]="{'Url': '/register/investment/edit?goveva=true&email=', 'method':'put', 'menu': 'investment'}" (click)="confirmDelete(director._id)">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
  
  
                  </tr>
                </tbody>
  
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete investment details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteInvestment()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>